<body *ngIf="isDisplayed">
    <div *ngFor="let age of ages; let i = index" class="filter-radio-input">
        <input [id]="'age-' + i" class="radio-btn" type="radio" name="age"
               [value]="i" [(ngModel)]="selectedAgeIndex" [checked]="i === selectedAgeIndex"/>

        <!-- under 19 yo -->
        <label *ngIf="i === 0" [for]="'age-' + i"> {{ ('watch.ranking_modal.age.under' |
            translate) + ' ' + age.max + ' ' + ('watch.ranking_modal.age.years_old' |
            translate) }}</label>

        <!-- 25 to 55 yo -->
        <label *ngIf="i > 0  && i < (ages.length - 1)" [for]="'age-' + i"> {{ age.min + ' ' +
            ('watch.ranking_modal.age.to' | translate) + ' '
            + age.max + ' ' +  ('watch.ranking_modal.age.years_old' | translate) }}</label>

        <!-- 99yo and more -->
        <label *ngIf="i === (ages.length - 1)" [for]="'age-' + i"> {{ age.min + ' ' +
            ('watch.ranking_modal.age.years_old' | translate) + ' ' + (
            'watch.ranking_modal.age.and_more' | translate) }}</label>
    </div>
</body>
